<template>
  <div class="upload-container">
    <div @click.stop="openDg" class="hd">
      <slot>
        <el-button
          :style="{ background: color, borderColor: color }"
          icon="el-icon-upload"
          size="mini"
          type="primary"
          >{{ ButtonText }}</el-button
        >
      </slot>
    </div>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <el-upload
        :multiple="multiple"
        :file-list="fileList"
        :show-file-list="true"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        action
        :limit="limit"
        :accept="accept"
        :on-exceed="handleExceed"
        drag
        class="editor-slide-upload"
        :http-request="uploadRequest"
        ref="upload"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div slot="tip" class="el-upload__tip">
          <span>只能上传{{ accept }}的文件</span>
          <span v-if="sizeMax"
            >，且不超过<span class="danger">{{ sizeMax > 1024 ? `${sizeMax / 1024}MB` : `${sizeMax}KB` }}</span></span
          >
          <span v-if="tips"
            >，建议<span class="danger">{{ tips }}</span
            >。</span
          >
        </div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { getToken } from 'api/qiniu'
/* eslint-disable no-underscore-dangle */
import { Dialog, Upload } from 'element-ui';
import { upload } from '@/api';
// import { fetchStsToken } from '@/api';

// const OSS = require('ali-oss');

localStorage.debug = 'ali-oss';

export default {
  name: 'EditorSlideUpload',
  components: {
    ElDialog: Dialog,
    ElUpload: Upload
  },
  props: {
    color: {
      type: String,
      default: '#1890ff'
    },
    accept: {
      type: String,
      default() {
        return '*';
      }
    },
    multiple: {
      type: Boolean,
      default() {
        return false;
      }
    },
    ButtonText: {
      type: String,
      default() {
        return '图片上传';
      }
    },
    limit: {
      type: Number,
      default() {
        return 1;
      }
    },
    // 单位kb
    sizeMax: {
      type: Number,
      default() {
        return 0;
      }
    },
    tips: {
      type: String,
      default() {
        return '';
      }
    },
    uploadType: {
      type: Object,
      default() {
        return {
          isActon: false,
          action: () => ({})
        };
      }
    },
    before: {
      type: Function,
      default: () => true
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      listObj: {},
      fileList: []
    };
  },
  methods: {
    openDg() {
      this.dialogVisible = true;
      this.fileList = [];
      this.listObj = {};
    },
    checkAllSuccess() {
      return Object.keys(this.listObj).every(item => this.listObj[item].hasSuccess);
    },
    handleExceed() {
      this.$message.warning('超出文件数量限制，需要上传请先删除！');
    },
    handleSubmit() {
      if (!this.checkAllSuccess()) {
        this.$message.warning('请等待文件上传完成，如有异常请刷新页面重新上传！');
        return;
      }
      this.$emit('successCBK', Object.keys(this.listObj).map(uid => this.listObj[uid]));
      this.listObj = {};
      this.fileList = [];
      this.dialogVisible = false;
    },
    handleSuccess(response, file) {
      const { uid } = file;
      const objKeyArr = Object.keys(this.listObj);
      for (let i = 0, len = objKeyArr.length; i < len; i += 1) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          this.listObj[objKeyArr[i]].url = response.file_id;
          this.listObj[objKeyArr[i]].hasSuccess = true;
          return;
        }
      }
    },
    handleRemove(file) {
      const { uid } = file;
      const objKeyArr = Object.keys(this.listObj);
      for (let i = 0, len = objKeyArr.length; i < len; i += 1) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]];
          return;
        }
      }
    },
    beforeUpload(file) {
      if (!this.before(file)) return false;
      this.listObj[file.uid] = {
        hasSuccess: false,
        uid: file.uid,
        name: file.name
      };
      if (this.sizeMax && file.size > this.sizeMax * 1024) {
        if (this.sizeMax > 1024) {
          this.$message.warning(`资源不能大于${this.sizeMax / 1024}MB，请先压缩！`);
          return false;
        }
        this.$message.warning(`资源不能大于${this.sizeMax}KB，请先压缩！`);
        return false;
      }
      return true;
    },
    uploadRequest(option) {
      const uploadFun = this.uploadType.isActon ? this.uploadType.action : upload;
      const formData = new FormData();
      formData.append('file', option.file);
      this.$nextTick(() => {
        Object.keys(this.params).forEach(key => {
          formData.append(key, this.params[key]);
        });
        uploadFun({
          headers: { 'Content-Type': 'multipart/form-data' },
          method: 'post',
          data: formData,
          config: {
            timeout: 300000
          },
          onUploadProgress: progressEvent => {
            // 原生获取上传进度的事件
            if (progressEvent.lengthComputable) {
              // 属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
              // 如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
              option.onProgress({ percent: Math.floor((progressEvent.loaded / progressEvent.total) * 99) }); // 触发el-upload组件的onProgress方法
            }
          }
        }).then(res => {
          if (res && res.data) {
            option.onProgress({ percent: 100 });
            option.onSuccess(res.data, option.file); // 触发el-upload组件的onSuccess方法
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.upload-container > .hd {
  display: inline-block;
}
.editor-slide-upload {
  /deep/ .el-upload--picture-card {
    width: 100%;
  }
}
.el-upload__tip .danger {
  color: @danger;
}
</style>
